import { AfterContentInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { hasContentProjection } from '@app/core/helpers/content-projection';

@Component({
    selector: 'ins-product-header',
    templateUrl: 'product-header.component.html',
    styleUrls: ['product-header.component.scss'],
})
export class ProductHeaderComponent implements AfterContentInit {
    @Input() callToActionUrl: string;
    @Input() imgCentered: boolean;
    @Input() hasNoMinHeight: boolean = false;
    @ViewChild('aggregate', { static: true }) aggregate: ElementRef;

    public hasAggregateContent: boolean = false;

    ngAfterContentInit(): void {
        this.hasAggregateContent = hasContentProjection(this.aggregate.nativeElement);
    }
}
